import React from "react";
import { Route, RouteProps } from "react-router";

const PrivateRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  return <Route {...rest} render={() => children} />;
};

export default PrivateRoute;
